import { useEffect, useRef, useState } from "react";
import styles from "./PlateOptions.module.css";
import { RegistrationName } from "../RegistrationName/RegistrationName";
import { ErrorModal } from "../UI/ErrorModal";
import { TypeOfTransport } from "../Options/TypeOfTransport/TypeOfTransport";
import { PositionPlate } from "../PositionPlate/PositionPlate";
import { SelectOption } from "../Options/SelectOption/SelectOption";
import { OptionPopup } from "../Options/Popups/OptionPopup";

import "../Options/option-box.css";
import "../Options/Popups/option-popup.css";
import size from "../../img/size.png";
import material from "../../img/material.png";
import fontStyle from "../../img/font-style.png";
import border from "../../img/border.png";
import badge from "../../img/badge.png";
import slogan from "../../img/slogan.png";
import { CategoryPlate } from "../Options/CategoryPlate/CategoryPlate";

export function PlateOptions(props) {
  const plateBuilder = props.plateBuilder;
  const textRef = useRef(null);
  const searchParams = new URLSearchParams(document.location.search);
  const optionArr = [
    {
      image: size,
      option: "Size",
      result: props.choosedOptions.plateSizeFront,
      resultRear: props.choosedOptions.plateSizeRear,
      active: true,
    },
    {
      image: material,
      option: "Plate Material",
      result: props.choosedOptions.plateMaterial,
      active: true,
    },
    {
      image: fontStyle,
      option: "Font Style",
      result: plateBuilder["font-family"].map((item) => {
        return item.font === props.choosedOptions.fontStyle ? item.name : "";
      }),
      active: [
        "Regular",
        "Acrylic",
        "Silver",
        "Black",
        "Honeycomb",
        "Silver Mirror",
        "Tinted",
        "Flexi",
      ],
    },
    {
      image: border,
      option: "Border Style",
      result: props.choosedOptions.borderWidth,
      active: [
        "Regular",
        "Acrylic",
        "Honeycomb",
        "Tinted",
        "Flexi",
        "3D Domed",
        "4D Raised",
        "5D Raised",
      ],
    },
    {
      image: badge,
      option: "Left Badge",
      result:
        props.choosedOptions.customBadgeTextLeft !== "" &&
        props.choosedOptions.customBadgeTextLeft !== "null"
          ? props.choosedOptions.customBadgeTextLeft
          : props.choosedOptions.badgeLeftName,
      active: [
        "Regular",
        "Acrylic",
        "Honeycomb",
        "Tinted",
        "Flexi",
        "3D Domed",
        "4D Raised",
        "5D Raised",
      ],
    },
    {
      image: badge,
      option: "Right Badge",
      result:
        props.choosedOptions.customBadgeTextRight !== "" &&
        props.choosedOptions.customBadgeTextRight !== "null"
          ? props.choosedOptions.customBadgeTextRight
          : props.choosedOptions.badgeRightName,
      active: [
        "Regular",
        "Acrylic",
        "Honeycomb",
        "Tinted",
        "Flexi",
        "3D Domed",
        "4D Raised",
        "5D Raised",
      ],
    },
    {
      image: slogan,
      option: "Slogan",
      result: props.choosedOptions.sloganStyle,
      active: [
        "Regular",
        "Acrylic",
        "Honeycomb",
        "Tinted",
        "Flexi",
        "3D Domed",
        "4D Raised",
        "5D Raised",
      ],
    },
  ];
  const updateDesign = () => {
    props.updateChoosedOptions({
      designRequired:
        props.choosedOptions.designRequired === "true" ? "false" : "true",
    });
  };
  const findFontStyle = (category) => {
    
    const material =
      props.choosedOptions.plateMaterial !== "null"
        ? props.choosedOptions.plateMaterial
        : "Regular";
    return plateBuilder["font-family"].find((item) => {
      if (
        item.font === "Dome4D" ||
        item.font === "Dome5D" ||
        item.font === "laser3d webfont"
      ) {
        return (
          item.category.includes(category) &&
          item.font === props.choosedOptions.fontStyle &&
          item.material.includes(material) &&
          item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) 
        );
      } else {
        return (
          item.category.includes(category) &&
          item.font === props.choosedOptions.fontStyle &&
          item.material.includes(material)
        );
      }
    });
  };
  const findMaterial = (category) => {
    return plateBuilder["plate-type"].find((item) => {
      return (
        item.category.includes(category) &&
        item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) &&
        item.type === props.choosedOptions.plateMaterial
      );
    });
  };
  const findFrontSize = (category) => {
    const material =
      props.choosedOptions.plateMaterial !== "null"
        ? props.choosedOptions.plateMaterial
        : "Regular";
    return plateBuilder["plate-size"].find((item) => {
      return (
        item.category.includes(category) &&
        item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) &&
        item.material.includes(material) &&
        item.size === props.choosedOptions.plateSizeFront &&
        !item.onlyRear
      );
    });
  };
  const findRearSize = (category) => {
    const material =
      props.choosedOptions.plateMaterial !== "null"
        ? props.choosedOptions.plateMaterial
        : "Regular";
    return plateBuilder["plate-size"].find((item) => {
      return (
        item.category.includes(category) &&
        item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) &&
        item.material.includes(material) &&
        item.size === props.choosedOptions.plateSizeRear
      );
    });
  };
  useEffect(() => {
    if (props.choosedOptions.fontStyle !== "null") {
      const findActivefontStyle = findFontStyle(
        props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard"
      );
      if (!findActivefontStyle) {
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
          props.choosedOptions.fontStyle === "Dome4D" ||
          props.choosedOptions.fontStyle === "Dome5D") ?
           openModalPopup("fontBothD"):
           openModalPopup("font") 

      }
    }
    if (props.choosedOptions.plateMaterial !== "null") {
      const findActiveMaterial = findMaterial(
        props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard"
      );
      if (!findActiveMaterial) {
        openModalPopup("material");
      }
    }
  }, [props.choosedOptions]);
  useEffect(() => {
    
    if (props.choosedOptions.plateSizeFront !== "null") {
      const findActiveFrontSize = findFrontSize(
        props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard"
      );
      const findActiveRearSize = findRearSize(
        props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard"
      );
      if (!findActiveFrontSize && findActiveRearSize) {
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
        props.choosedOptions.fontStyle === "Dome4D" ||
        props.choosedOptions.fontStyle === "Dome5D")
          ? openModalPopup("sizeFrontD")
          : openModalPopup("sizeFront");
      } else if (!findActiveFrontSize && !findActiveRearSize) {
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
        props.choosedOptions.fontStyle === "Dome4D" ||
        props.choosedOptions.fontStyle === "Dome5D")
          ? openModalPopup("sizeBothD")
          : openModalPopup("sizeBoth");
      }
    }
    if (props.choosedOptions.plateSizeRear !== "null") {
      const findActiveRearSize = findRearSize(
        props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard"
      );
      const findActiveFrontSize = findFrontSize(
        props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard"
      );
      if (!findActiveRearSize && findActiveFrontSize) {
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
        props.choosedOptions.fontStyle === "Dome4D" ||
        props.choosedOptions.fontStyle === "Dome5D")
          ? openModalPopup("sizeRearD")
          : openModalPopup("sizeRear");
      } else 
      if (!findActiveRearSize && !findActiveFrontSize) {
        (props.choosedOptions.fontStyle === "laser3d webfont" ||
        props.choosedOptions.fontStyle === "Dome4D" ||
        props.choosedOptions.fontStyle === "Dome5D")
          ? openModalPopup("sizeBothD")
          : openModalPopup("sizeRBoth");
      }
    }
  }, [props.choosedOptions.categoryPlate, props.choosedOptions.plateMaterial]);
  useEffect(() => {
    if (props.choosedOptions.categoryPlate.includes("standard")) {
      props.updateChoosedOptions({ fullHeightBadge: "false" });
    }
  }, [
    props.choosedOptions.badgeInsideBorder,
    props.choosedOptions.categoryPlate,
    props.choosedOptions.borderWidth,
  ]);

  useEffect(() => {
    if (
      (props.choosedOptions.fontStyle !== "laser3d webfont" &&
        props.choosedOptions.plateMaterial === "3D Domed") ||
      (props.choosedOptions.fontStyle !== "Dome4D" &&
        props.choosedOptions.plateMaterial === "4D Raised") ||
      (props.choosedOptions.fontStyle !== "Dome5D" &&
        props.choosedOptions.plateMaterial === "5D Raised")
    ) {
      props.updateChoosedOptions({
        plateMaterial: "Regular",
      });
    }
  }, [props.choosedOptions.fontStyle]);

  useEffect(() => {
    if (
      props.choosedOptions.showBSAU === "true" &&
      (props.choosedOptions.hasCustomBadgeRight === "true" ||
        props.choosedOptions.badgeRight !== "null")
    ) {
      openModalPopup("bsau");
      props.updateChoosedOptions({
        badgeRight: "null",
        badgeColorRight: "null",
        badgeRightName: "null",
        hasCustomBadgeRight: "false",
        customBadgeImageRight: "null",
        customBadgeTextRight: "null",
        customBadgeTextColorRight: "null",
        customBadgeRotationRight: "false,",
      });
    }
  }, [props.choosedOptions.showBSAU]);
  useEffect(() => {
    if (
      props.choosedOptions.borderWidth !== "null" &&
      props.choosedOptions.borderWidth !== "None" &&
      props.choosedOptions.badgeInsideBorder == "false" &&
      props.choosedOptions.categoryPlate.includes("show")
    ) {
      props.updateChoosedOptions({
        fullHeightBadge: "true",
      });
    }
  }, [
    props.choosedOptions.borderWidth,
    props.choosedOptions.badgeInsideBorder,
  ]);

  useEffect(() => {
    if (searchParams.get("ShowPlateMaterial") === "true") {
      props.openPopup("Plate Material");
    }
  }, []);
  useEffect(() => {
    let fontPrice = 0;
    props.plateBuilder["font-family"].map((item) => {
      if (item.font === props.choosedOptions.fontStyle) {
        fontPrice = item.price;
      }
    });
    plateBuilder.price.forEach((material) => {
      const plateMaterial =
        props.choosedOptions.plateMaterial !== "null"
          ? props.choosedOptions.plateMaterial
          : "Regular";
      if (material.material === plateMaterial) {
        material.prices.forEach((size) => {
          if (size.size === props.choosedOptions.plateSizeFront) {
            const design =
              props.choosedOptions.designRequired === "true" ? 14 : 0;
            props.updateChoosedOptions({
              frontPrice: +size.price + +fontPrice + design,
            });
          }
          if (size.size === props.choosedOptions.plateSizeRear) {
            const design =
              props.choosedOptions.designRequired === "true" ? 14 : 0;
            props.updateChoosedOptions({
              rearPrice: +size.price + +fontPrice + design,
            });
          }
        });
      }
    });
  }, [
    props.choosedOptions.plateMaterial,
    props.choosedOptions.fontStyle,
    props.choosedOptions.plateSizeFront,
    props.choosedOptions.plateSizeRear,
    props.choosedOptions.designRequired,
  ]);

  const openModalPopup = (value, list) => {
    props.checkValid({
      isValid: false,
      typePlate: value,
      list: list,
    });
  };

  return (
    <>
      {!props.isValid.isValid && (
        <ErrorModal
          updateChoosedOptions={props.updateChoosedOptions}
          addFocus={props.addFocus}
          choosedOptions={props.choosedOptions}
          closeModal={props.checkValid}
          list={props.isValid.list}
          messageType={props.isValid.typePlate}
        ></ErrorModal>
      )}
      <div className={styles["plate-options"]}>
        <h3 className={styles["plate-options__title"]}>
          Configure your plate options
        </h3>
        <RegistrationName
          isDefaultName={props.isDefaultName}
          addFocus={props.addFocus}
          inputRef={props.inputRef}
          updateRegisterName={props.updateChoosedOptions}
          onClick={props.checkValid}
          choosedOptions={props.choosedOptions}
        ></RegistrationName>
        <CategoryPlate
          plateBuilder={plateBuilder}
          updateChoosedOptions={props.updateChoosedOptions}
          choosedOption={props.choosedOptions}
          openModalFormCategory={props.handleOpenModalFormCategory}>
          
        </CategoryPlate>
        <TypeOfTransport
          plateBuilder={plateBuilder}
          updateChoosedOptions={props.updateChoosedOptions}
          choosedOption={props.choosedOptions}
        ></TypeOfTransport>
        {props.choosedOptions.typeOfTransport === "car" && (
          <PositionPlate
            updateTypeOfTransport={props.updateChoosedOptions}
            choosedOption={props.choosedOptions}
          ></PositionPlate>
        )}
        {optionArr.map((item) => {
          if (
            item.active === true ||
            props.choosedOptions.plateMaterial === "null"
          ) {
            return (
              <SelectOption
                choosedOptions={props.choosedOptions}
                resultRear={item.resultRear}
                result={item.result}
                key={item.option}
                image={item.image}
                option={item.option}
                openPopup={props.openPopup}
              ></SelectOption>
            );
          } else if (item.active.includes(props.choosedOptions.plateMaterial)) {
            return (
              <SelectOption
                choosedOptions={props.choosedOptions}
                resultRear={item.resultRear}
                result={item.result}
                key={item.option}
                image={item.image}
                option={item.option}
                openPopup={props.openPopup}
              ></SelectOption>
            );
          }
        })}
        {props.activePopup && (
          <OptionPopup
            openModal={props.checkValid}
            plateBuilder={plateBuilder}
            choosedOptions={props.choosedOptions}
            updateChoosedOptions={props.updateChoosedOptions}
            closePopup={props.openPopup}
            activePopup={props.activePopup}
          ></OptionPopup>
        )}
        {props.choosedOptions.categoryPlate.includes("show") && (
          <>
          {(props.choosedOptions.plateMaterial !== "Silver" && 
            props.choosedOptions.plateMaterial !== "Black" &&
            props.choosedOptions.plateMaterial !== "Silver Mirror" &&
            props.choosedOptions.plateMaterial !== "Pressed Metal Black" &&
            props.choosedOptions.plateMaterial !== "Pressed Metal" 
          ) && (
            <>
              <div className="radio-buttons flex flex-wrap items-center">
                <div
                  className={
                    props.choosedOptions.showBSAU === "true"
                      ? " switcher switcher--active"
                      : " switcher"
                  }
                  onClick={() =>
                    props.updateChoosedOptions({
                      showBSAU:
                        props.choosedOptions.showBSAU === "true"
                          ? "false"
                          : "true",
                    })
                  }
                >
                  BSAU mark?
                </div>
              </div>
            </>
          )}
            {props.choosedOptions.designRequired !== "hide" && (
              <>
                <div className="radio-buttons flex flex-wrap items-center">
                  <label for="text">
                    <div
                      className={
                        props.choosedOptions.designRequired === "true"
                          ? " switcher switcher--active"
                          : " switcher"
                      }
                      onClick={updateDesign}
                    >
                      Design required
                    </div>
                  </label>
                </div>
              </>
            )}
          </>
        )}
        {props.choosedOptions.borderWidth !== "null" &&
          props.choosedOptions.borderWidth !== "None" &&
          (props.choosedOptions.hasCustomBadgeLeft === "true" ||
            props.choosedOptions.hasCustomBadgeRight === "true" ||
            props.choosedOptions.badgeLeft !== "null" ||
            props.choosedOptions.badgeRight !== "null") &&
            props.choosedOptions.categoryPlate.includes("show") && (
            <div className="radio-buttons flex flex-wrap items-center">
              <div
                className={
                  props.choosedOptions.badgeInsideBorder === "true"
                    ? " switcher switcher--active"
                    : " switcher"
                }
                onClick={() =>
                  props.updateChoosedOptions({
                    badgeInsideBorder:
                      props.choosedOptions.badgeInsideBorder === "true"
                        ? "false"
                        : "true",
                  })
                }
              >
                {" "}
                Badge positioning{" "}
              </div>
            </div>
          )}
        {((props.choosedOptions.borderWidth !== "null" &&
          props.choosedOptions.borderWidth !== "None" &&
          props.choosedOptions.badgeInsideBorder === "true") ||
          props.choosedOptions.borderWidth === "null" ||
          props.choosedOptions.borderWidth === "None") &&
          (props.choosedOptions.hasCustomBadgeLeft === "true" ||
            props.choosedOptions.hasCustomBadgeRight === "true" ||
            props.choosedOptions.badgeLeft !== "null" ||
            props.choosedOptions.badgeRight !== "null") &&
          props.choosedOptions.breakLine === "true" &&
          props.choosedOptions.categoryPlate.includes("show") && (
            <div className="radio-buttons flex flex-wrap items-center">
              <div
                className={
                  props.choosedOptions.fullHeightBadge === "true"
                    ? " switcher switcher--active"
                    : " switcher"
                }
                onClick={() =>
                  props.updateChoosedOptions({
                    fullHeightBadge:
                      props.choosedOptions.fullHeightBadge === "true"
                        ? "false"
                        : "true",
                  })
                }
              >
                Full height badge{" "}
              </div>
            </div>
          )}
        {props.choosedOptions.designRequired === "true" && (
          <div className="textarea">
            <textarea
              placeholder="Populate this box with the design requirement(s) you are looking for that differ from the generated image"
              id="text"
              value={props.choosedOptions.designText}
              onChange={(e) =>
                props.updateChoosedOptions({ designText: e.target.value })
              }
            />
          </div>
        )}
      </div>
    </>
  );
}
